import { ThemeProvider } from '@mui/material/styles';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { LoadingIndicator } from '@adflow/frontend/ui-graphics';
import { GlobalStyles, muiTheme } from '@adflow/frontend/ui-theme';
import { HubToastContainer } from '@adflow/frontend/ui-toasts';
import { UserProvider } from '@adflow/frontend/util-auth';
import { BatchedNavActionProvider } from '@adflow/frontend/util-router';
import { WebsocketProvider } from '@adflow/frontend/util-websockets';

export function Root() {
	return (
		<>
			<ThemeProvider theme={muiTheme}>
				<HubToastContainer />
				<Suspense fallback={<LoadingIndicator />}>
					<BatchedNavActionProvider>
						<UserProvider>
							<WebsocketProvider>
								<Outlet />
							</WebsocketProvider>
						</UserProvider>
					</BatchedNavActionProvider>
				</Suspense>
			</ThemeProvider>
			<GlobalStyles />
		</>
	);
}
